var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexagonGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 85,
    viewBox: "0 0 79 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_148_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1542 2.24111C36.6998 -0.383297 42.3002 -0.383297 46.8458 2.24111L70.6923 16.0089C75.2379 18.6333 78.0381 23.4834 78.0381 28.7322V56.2678C78.0381 61.5166 75.2379 66.3667 70.6923 68.9911L46.8458 82.7589C42.3002 85.3833 36.6998 85.3833 32.1542 82.7589L8.30769 68.9911C3.76208 66.3667 0.961868 61.5166 0.961868 56.2678V28.7322C0.961868 23.4834 3.76208 18.6333 8.30769 16.0089L32.1542 2.24111Z",
    fill: "#25D076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7007 3.18779C36.9081 0.758648 42.0919 0.758648 46.2993 3.18779L70.1457 16.9556C74.3531 19.3847 76.945 23.8739 76.945 28.7322V56.2678C76.945 61.1261 74.3531 65.6153 70.1457 68.0444L46.2993 81.8122C42.0919 84.2414 36.9081 84.2414 32.7007 81.8122L8.85425 68.0444C4.64686 65.6153 2.055 61.1261 2.055 56.2678V28.7322C2.055 23.8739 4.64686 19.3847 8.85425 16.9556L32.7007 3.18779Z",
    stroke: "url(#paint0_linear_148_2379)",
    strokeOpacity: 0.6,
    strokeWidth: 2.18626
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_148_2379",
    x: -10.8291,
    y: -11.5181,
    width: 100.658,
    height: 108.036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.89552
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_148_2379"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_148_2379",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_2379",
    x1: 11.0694,
    y1: -6.32639,
    x2: 71.0208,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonGreen);
export default __webpack_public_path__ + "static/media/hexagon-green.f4f7ff72ebaa495c58b354703fc07b9b.svg";
export { ForwardRef as ReactComponent };